module.exports = __webpack_public_path__ + "img/bbfe577.png";